// @flow

const imageFileDropStyles = {
  root: (theme) => ({
    display: 'flex',
    alignItems: 'center'
  }),

  wrapper: (theme) => ({
    margin: theme.spacing(1),
    position: 'relative',
    cursor: 'pointer',
    '&:focus, &:hover': {
      outline: 'none'
    }
  }),

  dropZone: (theme) => ({
    border: `2px dashed ${theme.palette.primary.light}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    cursor: 'pointer',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }),

  dropZoneText: (theme) => ({
    fontSize: '0.9rem',
    color: theme.palette.text.secondary
  }),

  iconCtr: (theme) => ({
    marginRight: theme.spacing(1)
  }),

  fabProgress: (theme) => ({
    color: theme.palette.primary.light,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
    zIndex: 1
  })
};

export default imageFileDropStyles;